import { FC } from 'react'

interface LogoProps {
	style?: React.CSSProperties
}

export const Logo: FC<LogoProps> = ({ style }) => {
	return (
		<svg
			width="32"
			height="37"
			viewBox="0 0 32 37"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			style={style}>
			<g id="Group 147">
				<path
					id="Union"
					d="M5.81684 0C2.60429 0 0 2.6156 0 5.8421V26.2895C0 29.516 2.60429 32.1316 5.81684 32.1316H10.2937C11.1464 32.1316 11.9589 32.4944 12.5279 33.1295L14.5068 35.3378C15.3017 36.2249 16.6909 36.2249 17.4858 35.3378L19.4647 33.1295C20.0338 32.4944 20.8462 32.1316 21.6989 32.1316H26.1758C29.3883 32.1316 31.9926 29.516 31.9926 26.2895V5.8421C31.9926 2.6156 29.3883 0 26.1758 0H5.81684Z"
					fill="url(#paint0_linear_4258_599)"
				/>
				<g id="Vector">
					<path
						d="M21.0806 4.74707C21.6462 4.71059 22.2119 4.92948 22.6714 5.33078C22.9896 5.58615 23.1663 5.91448 23.3431 6.2793C24.4036 8.39523 25.3934 10.4018 26.8428 12.2259C27.3731 12.8825 27.9387 13.5027 28.575 14.0864C29.1053 14.5607 29.6709 14.9985 30.3072 15.3268C30.9435 15.6551 31.9926 16.1277 31.9926 16.1277V23.7175C25.4204 23.7175 18.86 23.7175 12.2782 23.7175C11.5005 23.7175 10.8642 23.7175 10.1218 23.7175C8.59788 23.7175 6.62208 21.3462 6.62208 19.9599C6.58673 19.5586 6.58673 19.1938 6.58673 18.7925C6.58673 16.8954 6.58673 14.9984 6.58673 13.1013C6.58673 11.861 6.83419 10.5842 7.08164 9.3803C7.29375 8.46826 7.57656 7.55622 8.07147 6.71715C8.49568 5.98751 9.09665 5.4402 9.87437 5.07539C10.4046 4.82002 10.9703 4.74705 11.5359 4.74705C14.7065 4.74705 17.9103 4.74707 21.0806 4.74707ZM10.8288 6.24289C10.2279 6.24289 9.66227 6.68066 9.52086 7.26437C9.2027 8.24937 8.88454 9.27086 8.56639 10.2559C8.49568 10.5112 8.49568 10.8396 8.70779 11.022C8.88454 11.2044 9.16735 11.2044 9.41481 11.2044C12.8792 11.2044 16.3082 11.2044 19.7726 11.2044C19.9847 11.2044 20.2322 11.1679 20.409 11.022C20.6564 10.8396 20.7271 10.5112 20.6918 10.2194C20.5857 9.23438 20.4443 8.21289 20.3029 7.22789C20.2322 6.64418 19.7019 6.16992 19.1363 6.24289C16.3789 6.24289 13.6216 6.27937 10.8288 6.24289ZM25.0046 11.5692C25.0046 12.007 25.0046 12.4448 25.0046 12.919C25.0399 14.5242 25.0753 16.1294 25.1106 17.7711C25.6763 18.3183 26.3833 18.7196 27.0549 19.0844C27.0549 18.6466 27.0196 18.1724 27.0196 17.7346C26.9842 17.2603 27.0196 16.7496 26.9842 16.2753C26.9842 15.874 26.9842 15.5092 26.9489 15.1079C26.9489 14.7431 26.9489 14.3418 26.9135 13.977C26.2772 13.2109 25.6056 12.4083 25.0046 11.5692ZM27.6559 17.1874C27.6913 17.6252 27.6559 18.0994 27.6913 18.5372C27.6913 18.7926 27.6913 19.0479 27.6913 19.3033C27.6913 19.3763 27.762 19.3763 27.7973 19.3763C28.3983 19.5952 28.9992 19.814 29.6356 19.96C29.6002 19.5587 29.6356 19.1939 29.6002 18.7926C29.5649 18.3548 29.6002 17.917 29.5649 17.4427C29.5649 17.005 29.5649 16.5307 29.5295 16.0929C28.8225 15.6551 28.1862 15.1444 27.5852 14.5607C27.6559 15.4727 27.6559 16.3483 27.6559 17.1874ZM9.73297 15.7646C9.132 15.9105 8.67244 16.4213 8.60174 17.0414C8.53103 17.6616 8.84919 18.2818 9.37946 18.5737C9.76832 18.7926 10.2632 18.7926 10.6874 18.6102C11.0763 18.4277 11.3591 18.0629 11.5005 17.6616C11.6773 17.0779 11.4652 16.4213 11.0056 16.02C10.6167 15.7646 10.1572 15.6551 9.73297 15.7646ZM19.3484 15.7646C18.8535 15.874 18.4293 16.2753 18.2879 16.7861C18.1465 17.2239 18.2172 17.7346 18.4647 18.0994C18.8182 18.6466 19.5605 18.902 20.1615 18.6831C20.5857 18.5372 20.9392 18.1724 21.0806 17.7346C21.2574 17.1509 21.0806 16.4213 20.5857 16.0564C20.2322 15.7646 19.7726 15.6551 19.3484 15.7646ZM30.3072 20.1789C30.9435 20.3248 31.9926 20.397 31.9926 20.397C31.9926 19.3452 32 17.7698 32 17.1874C32 17.1874 30.3072 16.5307 30.2365 16.5307C30.2719 17.7346 30.2719 18.975 30.3072 20.1789Z"
						fill="url(#paint1_linear_4258_599)"
					/>
					<path
						d="M9.88009 25.2473C9.88009 24.9853 10.0907 24.6662 10.3506 24.6662C11.2814 24.6662 12.1903 24.6662 13.1212 24.6662C13.381 24.6662 13.5917 24.8786 13.5917 25.1406C13.5917 25.4025 13.8023 25.6149 14.0621 25.6149C15.531 25.6149 17.0193 25.6149 18.4881 25.6149C18.748 25.6149 18.9586 25.4025 18.9586 25.1406C18.9586 24.8786 19.1692 24.6662 19.4291 24.6662C23.6203 24.6662 27.8112 24.6662 31.9926 24.6662C31.9926 25.6149 31.9926 26.0893 31.9339 26.4681C28.4429 26.8254 24.9487 27.1809 21.4678 27.5124C17.1462 27.5124 12.7943 27.5124 8.46864 27.5124C7.94896 27.5124 7.52769 27.0995 7.52769 26.5755C7.52769 26.0515 7.94897 25.6149 8.46865 25.6149C8.78086 25.6149 9.09872 25.6149 9.40964 25.6149C9.66948 25.6149 9.88009 25.5093 9.88009 25.2473Z"
						fill="url(#paint2_linear_4258_599)"
					/>
				</g>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_4258_599"
					x1="1.18491"
					y1="34.3888"
					x2="29.1129"
					y2="-1.17002"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#74C24F" />
					<stop offset="1" stopColor="#BFE456" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_4258_599"
					x1="7.52769"
					y1="23.2436"
					x2="31.0957"
					y2="14.8285"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#1D2F0F" />
					<stop offset="1" stopColor="#4D6D12" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_4258_599"
					x1="7.52769"
					y1="23.2436"
					x2="31.0957"
					y2="14.8285"
					gradientUnits="userSpaceOnUse">
					<stop stopColor="#1D2F0F" />
					<stop offset="1" stopColor="#4D6D12" />
				</linearGradient>
			</defs>
		</svg>
	)
}
